const TYPE_ABBREVIATION_LENGTH = 2

export const mapStoppageCodes = (stoppageCodes?: string[]) =>
  stoppageCodes?.map((code) => code.substring(TYPE_ABBREVIATION_LENGTH))
